import React, { useState } from "react";
import styles from "./DeliveryInformation.module.css";

function PickupForm(props) {
  const [formData, setFormData] = useState({
    name: "Mobb Medical",
    address: "116A Viceroy Rd,#5",
    city: "Concord",
    province: "ON",
    country: "CA-CANADA",
    zip: "L4K2M1",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    props.onChange(formData);
  };

  return (
    <form className={styles.container}>
      <div className={styles.heading}>
        <h2>Pickup Information</h2>
      </div>
      <div className={styles.controls}>
        <label htmlFor="name">Name</label>
        <input
          id="name"
          onChange={handleInputChange}
          type="text"
          required
          defaultValue="Mobb Medical"
          placeholder="Name"
          disabled
        />
      </div>
      <div className={styles.controls}>
        <label htmlFor="zip">Postal Code</label>
        <input
          type="text"
          id="zip"
          onChange={handleInputChange}
          required
          defaultValue="L4K2M1"
          placeholder="Postal Code"
          disabled
        />
      </div>
      <div className={styles.controls}>
        <label htmlFor="Address">Address</label>
        <textarea
          id="address"
          onChange={handleInputChange}
          required
          defaultValue="116A Viceroy Rd,#5"
          placeholder="Address"
          disabled
        />
      </div>
      <div className={styles.controls}>
        <label htmlFor="city">City</label>
        <input
          id="city"
          type="text"
          onChange={handleInputChange}
          required
          defaultValue="Concord"
          placeholder="City"
          disabled
        />
      </div>
      <div className={styles.controls}>
        <label htmlFor="province">Province</label>
        <input
          id="province"
          type="text"
          onChange={handleInputChange}
          required
          defaultValue="ON"
          placeholder="Province"
          disabled
        />
      </div>
      <div className={styles.controls}>
        <label htmlFor="country">Country</label>
        <input
          id="country"
          type="text"
          onChange={handleInputChange}
          placeholder="Country"
          value="CA"
          disabled
        />
      </div>
    </form>
  );
}

export default PickupForm;
